module.exports = __webpack_public_path__ + "835781da05ced5b66b4e4b73757e4b41.pdf";